import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PricingPlan } from '../../types';


interface CommonState {
    pricingPlan: PricingPlan | null;
}

const initialState: CommonState = {
    pricingPlan: null,
};

export const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setPricingPlan: (state, action: PayloadAction<PricingPlan | null>) => {
            state.pricingPlan = action.payload;
        },
    },
});

export const { setPricingPlan } = commonSlice.actions;

export default commonSlice.reducer;